<template>
  <v-layout>
    <b-row>
      <b-col md="6">
        <b-card :border-variant="!errors.has('login.*') ? 'success' : 'danger'"
                :header="$t('titles.login')"
                header-tag="header"
                :header-bg-variant="!errors.has('login.*') ? 'success' : 'danger'"
                header-text-variant="white">
          <blocking-container v-if="$wait.is('login')"></blocking-container>
          <b-form @submit.prevent="validate" data-vv-scope="login">

            <b-form-group :label="`${$t('fields.email')}:`">
              <b-form-input v-validate="'required|email|max:255'"
                            data-vv-value-path="localValue"
                            data-vv-name="email"
                            :data-vv-as="$t('fields.email')"
                            id="email"
                            type="text"
                            v-model="user.email"
                            :state="errors.has('login.email') ? false : null"
                            aria-describedby="input-feedback-email"
                            :placeholder="$t('placeholders.email')">
              </b-form-input>

              <b-form-invalid-feedback id="input-feedback-email">
                <template v-show="errors.has('login.email')">{{ errors.first('login.email') }}</template>
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group id="exampleInputGroup2"
                          :label="`${$t('fields.password')}:`">
              <b-form-input id="password"
                            v-validate="'required|min:6|max:255'"
                            data-vv-value-path="localValue"
                            data-vv-name="password"
                            :data-vv-as="$t('fields.password')"
                            type="password"
                            v-model="user.password"
                            :state="errors.has('login.password') ? false : null"
                            aria-describedby="input-feedback-password"
                            :placeholder="$t('placeholders.password')">
              </b-form-input>

              <b-form-invalid-feedback id="input-feedback-password">
                <template v-show="errors.has('login.password')">{{ errors.first('login.password') }}</template>
              </b-form-invalid-feedback>
            </b-form-group>

            <div class="d-flex align-items-center justify-content-between">
              <div>
                <b-link :to="{ name: 'forgot.index' }">{{ $t('actions.forgot_password') }}</b-link>
                <br>
                <b-link :to="{ name: 'resend.index' }">{{ $t('titles.resend_verification') }}</b-link>
              </div>

              <b-button class="float-right" :disabled="errors.has('login.*')" type="submit"
                        :variant="'outline-' + (!errors.has('login.*') ? 'success' : 'danger')"> {{ $t('actions.continue') }}
              </b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
      <b-col md="6">
        <RegisterForm />
      </b-col>
    </b-row>
  </v-layout>
</template>

<script>

import VLayout from '@/layouts/Default';
import BlockingContainer from '@/components/BlockingContainer';
import RegisterForm from '@/views/Register/Form';

export default {

  name: 'LoginIndex',

  metaInfo() {
    return {
      title: this.$t('titles.login'),
    };
  },

  components: {
    VLayout,
    BlockingContainer,
    RegisterForm,
  },

  data() {
    return {
      user: {
        email: null,
        password: null,
      },
    };
  },

  methods: {
    validate() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$wait.start('login');
          this.login();
        }
      });
    },
    loginAfterRegister(user) {
      this.$wait.start('login');
      this.$store.dispatch('auth/login', {
        redirect: 'my-account.index',
        user,
        callback: () => this.$wait.end('login'),
      });
    },
    login() {
      this.$store.dispatch('auth/login', {
        redirect: 'my-account.index',
        user: this.user,
        callback: () => this.$wait.end('login'),
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Login/Index.vue